<template>
  <div class="container">
    <img class="img" src="/static/svg/404-img.svg" alt="404-image">
    <p class="p p--color p--mt p--text">
      <b><span class="p--text-size">¡Lo siento!</span></b>
      <br>
      No pudimos encontrar la página a la que quieres ir
    </p>
    <button @click="goBack" class="button button-large btn--size">Regresar</button>
  </div>
</template>

<script>
import mixins from '@/mixins/index'

export default {
  name: 'PageNotFound',
  mixins: [mixins],
  created: function () {
    this.doScroll(100)
  },
  methods: {
    goBack: function () {
      this.$router.go(-1)
    }
  }
}

</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 8em auto;
  }

  .img {
    width: 100%;
  }

  .p {
    text-align: center;
  }

  .p--color {
    color: $midnight-blue;
  }

  .p--mt {
    margin-top: 1em;
  }

  .p--text {
    font-size: 1.5em;
  }

  .p--text-size {
    font-size: 1.8em;
  }

  @media (min-width: 760px) {
    .img {
      width: 50%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/PageNotFound.vue